import { useOutletContext } from 'react-router-dom';
import { PdfViewerContainer } from '../Pdf/PdfViewerContainer';
import React from 'react';
import Box from '@mui/material/Box';

export default function PlanLot() {
  const infos = useOutletContext();
  const urlPdf = `${infos.settings.mediaBaseUrl}/maquette/BOOK/PV2D-pdf/${infos.lot.key}.pdf`;
  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        position: 'absolute',
      }}
    >
      <PdfViewerContainer url={urlPdf} pdfViewerNavigationFixed={false} />
    </Box>
  );
}
